import { CircleX, Search } from "lucide-react";
import "./SearchBar.css";

export default function SearchBar({
  value = "",
  onSearch = () => {},
  inputAriaLabel = "Rechercher un mot",
  placeholder = "tapez un mot…",
}) {
  const hasQuery = Boolean(value?.trim());

  return (
    <div className="search-bar">
      <Search
        className="search-bar__icon"
        size={20}
        color="#39210d"
        strokeWidth={1.5}
        aria-hidden="true"
      />
      <input
        className="search-bar__input"
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onSearch(e.target.value)}
        aria-label={inputAriaLabel}
      />
      <button
        type="button"
        className="search-bar__clear"
        onClick={() => onSearch("")}
        disabled={!hasQuery}
        aria-label="Effacer la recherche"
        title="Effacer la recherche"
      >
        <CircleX size={22} color="#39210d" strokeWidth={1.5} />
      </button>
    </div>
  );
}
